import { render, staticRenderFns } from "./youhuiquan.vue?vue&type=template&id=530e15e2&scoped=true"
import script from "./youhuiquan.vue?vue&type=script&lang=js"
export * from "./youhuiquan.vue?vue&type=script&lang=js"
import style0 from "./youhuiquan.vue?vue&type=style&index=0&id=530e15e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530e15e2",
  null
  
)

export default component.exports